import React from 'react';
import { Alert, Box, Stack, SelectChangeEvent, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { primary } from '_lex/_foundations/phxColors';
import { PolicyProvider, usePolicyContext } from './PolicyContext';
import { useRiskPoolOrgContext } from '../RiskPoolOrgContext';
import MetricsCards from './MetricsCards';
import OrganizationalTrends from './OrganizationalTrends';

function PolicyContent() {
  const { manualId, setManualId } = usePolicyContext();
  const { hasManualContent } = useRiskPoolOrgContext();

  const handleManualChange = (event: SelectChangeEvent<string>) => {
    setManualId(event.target.value);
  };

  const handleReportSelect = (reportType: string) => {
    // TODO: Navigate to report pages when they exist
    console.log(`Navigate to ${reportType} report`);
  };

  return (
    <Box sx={{ py: 3, px: 5, width: '1200px', maxWidth: '94vw', mx: 'auto' }}>
      <Stack spacing={6} sx={{ minWidth: 0 }}>
        {/* Point-in-time metrics section */}
        <Stack spacing={5}>
          {!hasManualContent && (
            <Alert severity='warning'>{t('dashboard.riskPool.riskPoolOrg.noManualContentWarning')}</Alert>
          )}
          <Box
            sx={{
              backgroundColor: primary[50],
              borderRadius: 2,
              p: 6,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Box>
              <Typography variant='subtitleMd'>
                {t('dashboard.riskPool.riskPoolOrg.pointInTimeMetrics.title')}
              </Typography>
              <Typography variant='bodySm' sx={{ color: 'text.secondary' }}>
                {t('dashboard.riskPool.riskPoolOrg.pointInTimeMetrics.asOf')}{' '}
                {(() => {
                  const yesterday = new Date();
                  yesterday.setDate(yesterday.getDate() - 1);
                  return `${String(yesterday.getMonth() + 1).padStart(2, '0')}/${String(yesterday.getDate()).padStart(2, '0')}/${yesterday.getFullYear()}`;
                })()}
              </Typography>
            </Box>
            <MetricsCards />
          </Box>
        </Stack>

        {/* Organizational Trends Chart with Filters */}
        <OrganizationalTrends
          selectedManual={manualId}
          onManualChange={handleManualChange}
          onReportSelect={handleReportSelect}
        />
      </Stack>
    </Box>
  );
}

export default function Policy() {
  return (
    <PolicyProvider>
      <PolicyContent />
    </PolicyProvider>
  );
}
